import KendoTreeListDataSourceMixin from './KendoTreeListDataSourceMixin'

export default {
    name: 'kendo-treelistdatasource',
    mixins: [ KendoTreeListDataSourceMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoTreeListDataSource/index.js